<template>
  <v-system-bar dark height="35" color="primary lighten-2" v-if="false">
    <v-spacer></v-spacer>INFORMACIÓN PEDIDOS NEGOCIO
    <v-spacer />
  </v-system-bar>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  data: () => {
    return {
      zcierresConsultando: [], //los ids de los zcierres en los que se están buscando pedidos
    };
  },
  watch: {
    getRestaurantesBossNegocioBruto(v) {
      console.log(v);
      let nuevosZ = v
        .map((r) =>
          r.confTpv && r.confTpv.cierreEnCurso ? r.confTpv.cierreEnCurso : false
        )
        .filter((r) => !!r);
      console.log(nuevosZ);
      let nuevosZAdd = nuevosZ.filter(
        (n) => !this.zcierresConsultando.includes(n)
      );
      console.log(nuevosZAdd);
      nuevosZAdd.map((z) => {
        //this.$store.dispatch("pedidos/getPedidosNegocioRealizandoTpvCierre", z);
        this.zcierresConsultando.push(z);
      });
      console.log(this.zcierresConsultando);
      console.log("cambio de cierre");
    },
  },
  computed: {
    ...mapState({
      zcierresAbiertosBruto: (state) => state.zcierres.zcierresAbiertos,
    }),
    ...mapGetters({
      negocioGestSlug: "app/negocioGestObj",
      numPedidosNegocio: "negocios/numPedidosNegocio",
      cantidadPedidos: "negocios/numCantidad",
      numRest: "negocios/numRestNegocio",
      getPedidosListadoBossNegocioTpv:
        "pedidos/getPedidosListadoBossNegocioTpv",
      getPedidosListadoBossNegocioOnline:
        "pedidos/getPedidosListadoBossNegocioOnline",
      getProductosListadoBossNegocio: "pedidos/getProductosListadoBossNegocio",
      getRestaurantesBossNegocioBruto:
        "restaurantes/getRestaurantesBossNegocio",
    }),
  },
};
</script>

<style>
</style>